/**
 * Skeleton loading screen for the teaser card layout.
 *
 * One placeholder block sized to the teaser card; it joins the shared shimmer
 * wave like every other skeleton shape.
 */

import { BaseSkeleton } from 'component/progress/base-skeleton';
import { View } from 'react-native';
import { TeaserScreenStyle } from 'system/teaser';

export function SkeletonTeaserScreen() {
    const TEASER_HEIGHT = 200;
    return (
        <View style={TeaserScreenStyle.teaser}>
            <BaseSkeleton borderRadius={8} height={TEASER_HEIGHT} width='100%' />
        </View>
    );
}
